const GhostColors = {
    RED: 'red',
    YELLOW: 'yellow',
    BLUE: 'blue',
    PINK: 'pink',
    WHITE: 'white',
    GREEN: 'green',
    PURPLE: 'purple',
    LIME: 'lime',
    CYAN: 'cyan',
}

export default GhostColors;